import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from "vue";
import NavigationBar from "../../components/NavigationBar.vue";
import FooterLogo from "@/components/FooterLogo.vue";
import { realTimeDataAxios } from "../../service/user.service";
import { machineTableAxios } from "@/service/admin.service";
import useComponentLoop from "@/util/component.loop";
import { computed } from "@vue/reactivity";
import { useRoute } from "vue-router";
import router from "@/router";
import { ROU_NAME } from "@/router/router.name";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const userInfo = ref({
  group: sessionStorage.getItem("group"),
});

const realTimeDataLoop = useComponentLoop(async () => {
  await realTimeDataAxios();
}, 1000 * 60);

onMounted(async () => {
  if (userInfo.value.group) {
    await machineTableAxios(userInfo.value.group).then(() => {
      realTimeDataLoop.start();
    });
  }
});

const title = computed(() => {
  if (route.path === "/dashboard") {
    return "DashBoard";
  } else if (route.path === "/detail") {
    return "Detail";
  } else if (route.path === "/mypage") {
    return "My Page";
  } else if (route.path === "/search") {
    return "Search";
  } else if (route.path === "/cardsearch") {
    return "Card Search";
  } else if (route.path === "/esgsearch") {
    return "ESG Search";
  } else {
    console.log("");
  }
});

onUnmounted(async () => {
  realTimeDataLoop.stop();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavigationBar, { title: _unref(title) }, null, 8, ["title"]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    }, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    })),
    _createVNode(FooterLogo)
  ], 64))
}
}

})